module.exports = __webpack_public_path__ + "images/price-index-686b577e.svg";